/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_SkusInputs */

const en_product_skus = /** @type {(inputs: Product_SkusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKUs`)
};

/**
* | output |
* | --- |
* | "SKUs" |
*
* @param {Product_SkusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const product_skus = /** @type {((inputs?: Product_SkusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_SkusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_product_skus(inputs)
});